import React, { useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [openModal, setOpenModal] = useState<null | 'terms' | 'privacy'>(null);
  return <footer className="bg-navy-900 text-slate-400 py-12 border-t border-navy-800" data-id="element-42">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-43">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-8" data-id="element-44">
          <div className="flex items-center gap-2" data-id="element-45">
            <ShieldCheck className="w-6 h-6 text-gold-500" data-id="element-46" />
            <span className="font-bold text-xl text-white tracking-tight" data-id="element-47">
              Arquitecto de Crédito <span className="text-gold-500" data-id="element-48">USA</span>
            </span>
          </div>
          <div className="flex gap-6 text-sm" data-id="element-49">
            <button onClick={() => setOpenModal('terms')} className="hover:text-gold-500 transition-colors" data-id="element-50">
              Términos y Condiciones
            </button>
            <button onClick={() => setOpenModal('privacy')} className="hover:text-gold-500 transition-colors" data-id="element-51">
              Política de Privacidad
            </button>
          </div>
        </div>

        <div className="text-center text-xs text-slate-500 space-y-4" data-id="element-52">
          <p data-id="element-53">
            Descargo de responsabilidad: Los resultados mostrados no son típicos
            y pueden variar. Arquitecto de Crédito USA proporciona material
            educativo y herramientas, pero no garantiza resultados específicos
            ni la eliminación de información precisa de su reporte de crédito.
            No somos una agencia de reparación de crédito ni brindamos
            asesoramiento legal.
          </p>
          <p data-id="element-54">
            &copy; {new Date().getFullYear()} Arquitecto de Crédito USA. Todos
            los derechos reservados.
          </p>
        </div>
      </div>

      {/* Terms Modal */}
      <Modal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-55">
        <p data-id="element-56">
          Este material es puramente educativo. No garantizamos resultados
          financieros específicos ni aumentos exactos en el puntaje de crédito.
          No somos una agencia de reparación de crédito, abogados, ni asesores
          financieros oficiales.
        </p>
        <p className="mt-4" data-id="element-57">
          Al adquirir nuestro producto, el usuario acepta que los resultados
          dependen de su propia aplicación del material, sus circunstancias
          financieras individuales y los procesos legales correspondientes con
          los burós de crédito en los Estados Unidos.
        </p>
      </Modal>

      {/* Privacy Modal */}
      <Modal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-58">
        <p data-id="element-59">
          En Arquitecto de Crédito USA protegemos tu información personal con la
          máxima seriedad. Tus datos están seguros con nosotros.
        </p>
        <ul className="mt-4 space-y-3 list-disc list-inside" data-id="element-60">
          <li data-id="element-61">
            <strong className="text-navy-900" data-id="element-62">No vendemos</strong> tu
            información a terceros bajo ninguna circunstancia.
          </li>
          <li data-id="element-63">
            Tus datos se usan{' '}
            <strong className="text-navy-900" data-id="element-64">únicamente</strong> para procesar
            la compra del producto digital y entregarte el acceso.
          </li>
          <li data-id="element-65">
            Almacenamos tu información con medidas de seguridad estándar de la
            industria y nunca la compartimos con anunciantes externos.
          </li>
        </ul>
        <p className="mt-4" data-id="element-66">
          Si en algún momento deseas que eliminemos tus datos, puedes
          solicitarlo y procederemos conforme a las leyes de protección de datos
          aplicables.
        </p>
      </Modal>
    </footer>;
}